import { json } from "react-router-dom";
import $api from "../http";
import { AxiosResponse } from "axios";

export default class BillingService {

    static async getBillings(provider_id) {
        return $api.get(`/billings`, {'params': {'provider_id': provider_id}})
    }

    static users(billing_id, new_user) {
        const user = {
            "login": "test",
            "password": "",
            "full_name": "",
            "is_juridical": false,
            "juridical_address": "",
            "actual_address": "",
            "flat_number": "",
            "entrance": "",
            "floor": "",
            "district": "",
            "building": "",
            "passport": "",
            "house_id": 0,
            "work_telephone": "",
            "home_telephone": "",
            "mobile_telephone": "",
            "web_page": "",
            "icq_number": "",
            "tax_number": "",
            "kpp_number": "",
            "email": "",
            "bank_id": 0,
            "bank_account": "",
            "comments": "",
            "personal_manager": "",
            "connect_date": 0,
            "is_send_invoice": false,
            "advance_payment": 0,
            "router_id": 0,
            "port_number": 0,
            "binded_currency_id": 0,
            "additional_params": [],
            "groups": [],
            "is_blocked": false,
            "balance": 0,
            "credit": 0,
            "vat_rate": 0,
            "sale_tax_rate": 0,
            "int_status": 0
        }
        for (var key in new_user) {
            user[key] = new_user[key]
        }
        return $api.post(`/billings/${billing_id}/users`, user)
    }

    static async billing_users(offset, limit, filter='', provider_id=null) {
        return $api.post('/billing_users', {limit, offset, filter, provider_id})
    }

    static async billing_user_groups(billing_id, user_id) {
        return $api.get(`/billing_users/${billing_id}/${user_id}/groups`)
    }

    static async billing_user(billing_id, user_id) {
        return $api.get(`/billing_users/${billing_id}/${user_id}`)
    }

    static async billing_user_reset_password(billing_id, user_id) {
        return $api.post(`/billings/${billing_id}/users/${user_id}/reset_password`)
    }

    static async billing_users_accounts(method, billing_id, user_id, data=null) {
        if (method === "GET") {
            return $api.get(`/billings/${billing_id}/users/accounts`, {'params': {'user_id': user_id}})
        }
        if (method === "PUT" && data) {
            return $api.put(`/billings/${billing_id}/users/accounts`, data)
        }
    }

    static async billing_user_servicelinks(billing_id, user_id) {
        return $api.get(`/billing_users/${billing_id}/${user_id}/servicelinks`)
    }

    static async billing_user_ip_services(billing_id, user_id) {
        return $api.get(`/billing_users/${billing_id}/${user_id}/ipservices`)
    }

    static async billing_payments(method, billing_id, user_id, account_id, data=null) {
        if (method === "GET") {
            return $api.get(`/billings/${billing_id}/users/${user_id}/accounts/${account_id}/payments`)
        }
        if (method === "POST" && data) {
            return $api.post(`/billings/${billing_id}/users/${user_id}/accounts/${account_id}/payments`, data)
        }
    }

    static async billing_promised_payments(method='GET', billing_id, user_id, account_id, data=null) {
        if (method === "GET") {
            return $api.get(`/billings/${billing_id}/users/${user_id}/accounts/${account_id}/promised_payments`)
        }
        if (method === "POST" && data) {
            return $api.post(`/billings/${billing_id}/users/${user_id}/accounts/${account_id}/promised_payments`, data)
        }
    }

    static async billing_currencies(method='GET', billing_id) {
        if (method === "GET") {
            return $api.get(`/billings/${billing_id}/currencies`)
        }
    }

    static async billing_paymentmethods(method='GET', billing_id) {
        if (method === "GET") {
            return $api.get(`/billings/${billing_id}/paymentmethods`)
        }
    }

    static async getBillingReportPayments(billing_id, time_start, time_end) {
        return $api.get(`/billings/${billing_id}/report_payments`, {'params': {'time_start': time_start, 'time_end': time_end}})
    }

    static async getBillingDiscountTransactions(billing_id, time_start, time_end) {
        return $api.get(`/billings/${billing_id}/report_discount_transactions`, {'params': {'time_start': time_start, 'time_end': time_end}})
    }

    static async getBillingReportTotalUsersService(billing_id, time_start, time_end) {
        return $api.get(`/billings/${billing_id}/report_total_users_service`, {'params': {'time_start': time_start, 'time_end': time_end}})
    }

    static async getBillingReportTotalPaymentsMonths(billing_id) {
        return $api.get(`/billings/${billing_id}/report_total_payments_months`, {'params': {'time_start': 11111}})
    }

    static async getBillingReportCountNewUsersMonths(billing_id) {
        return $api.get(`/billings/${billing_id}/report_count_new_users_months`)
    }

}